import { Currency } from '@kodiak-finance/sdk-core'
import { chainIdToNativeCurrencyName } from 'config/chains'
import { useMemo } from 'react'

import { useConnection } from './useConnection'

export const useCurrencyId = (currency: Currency | null | undefined): string | undefined => {
  const { chainId } = useConnection()

  return useMemo(() => {
    if (!currency) return undefined

    if (currency.isNative) {
      const nativeSymbol = chainIdToNativeCurrencyName[chainId]
      return nativeSymbol
    }

    if (currency.isToken) return currency.address

    throw new Error('Invalid currency')
  }, [currency, chainId])
}
